import $ from 'jquery';

export default () => {
  $('#goTop').on('click', () => {
    $('html,body').animate({ scrollTop: 0 }, 'slow');
    return false;       
  })

}



// WEBPACK FOOTER //
// ./assets/src/js/modules/goTop.js